import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ADMIN_EMAIL = 'admin@gmail.com';

function AdminRoute({ children }) {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/" />;
  }

  if (currentUser.email.toLowerCase() !== ADMIN_EMAIL.toLowerCase()) {
    return <Navigate to="/dashboard" />;
  }

  return children;
}

export default AdminRoute;
